import React, {FC} from "react"
import {RouteComponentProps} from "react-router-dom"

import {IndexRedirect, NestedRoute, withPartialRoute} from "@irati/utils/history/routing"
import {SEARCH} from "@irati-web/app/src/routeConfig"
import {LangLoader} from "@irati/utils/lang"
import AppContainer from "@irati/ui/src/AppContainer"
import {HasPermissionTo} from "@irati/utils/permissions"
import mainTheme from "@irati/ui/src/global/theme"

import DealInfo from "../containers/DealInfo"
import Deals from "../containers/Deals"
import HomePage from "../containers/HomePage"
import DealSuccess from "../containers/DealSuccess"
import DealRedemptionError from "../containers/DealRedemptionError"
import DealPayment from "../containers/DealPayment"
import DealSelectProducts from "../containers/DealSelectProducts"
import DealPaymentRedirectLanding from "../containers/DealPaymentRedirectLanding"
import TagLandingPage from "../containers/Tag"
import DealBrand from "../containers/DealBrand"
import Account from "./account"

interface Props extends RouteComponentProps {
  path: string
}

const Info: FC<Props> = ({match: {url}}) => (
  <>
    <NestedRoute match={url} exact path="/:urlSlug" title="Deal" component={DealInfo} />
    <NestedRoute match={url} exact path="/:urlSlug/redeem" component={DealSelectProducts} title="Redeem" />
    <NestedRoute match={url} exact path="/:urlSlug/pay" title="Payment" component={DealPayment} />
    <NestedRoute match={url} path="/:urlSlug/error/:checkoutId/:paymentOrderId" title="Redemption error" component={DealRedemptionError} />
    <NestedRoute
      match={url}
      path="/:urlSlug/payment-redirect/:checkoutId"
      title="Payment complete"
      component={DealPaymentRedirectLanding}
    />
    <NestedRoute match={url} path="/:urlSlug/success/:redemptionId" title="Deal Redeemed" component={DealSuccess} />
  </>
)

const PerksClient: FC<Props> = ({path, location}) => {
  const isPerksAccount = location.pathname.includes("/perks/account")

  return (
    <AppContainer mainBackground={isPerksAccount && mainTheme.colors.greys.white}>
      <HasPermissionTo permissions="perks">
        <LangLoader buckets={[SEARCH]}>
          <NestedRoute match={path} path="/discover" title="Home" component={HomePage} useGrid={false} />
          <NestedRoute match={path} path="/account" component={Account} useGrid={false} />
          <NestedRoute match={path} path="/categories/:category?" title="Deals" useGrid={false} component={Deals} />
          <NestedRoute match={path} path="/info" component={Info} useGrid={false} />
          <NestedRoute match={path} path="/brands/:dealBrandSlug" title="Brand" component={DealBrand} useGrid={false} />
          <NestedRoute match={path} path="/tag/:tagIdOrUrl" title="Loading tag..." component={TagLandingPage} useGrid={false} />
          <IndexRedirect match={{url: path}} to="/discover" />
        </LangLoader>
      </HasPermissionTo>
    </AppContainer>
  )
}

export default withPartialRoute(PerksClient)
